import React from 'react'
import { Box, Flex, Text, SimpleGrid, IconButton } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'

export const CalendarHeader = ({ monthYear, weekdayLabels, onPrevMonth, onNextMonth }) => {
  return (
    <Box mb={4}>
      <Flex justify="space-between" alignItems="center" mb={2}>
        <IconButton
          aria-label="Mês anterior"
          icon={<ChevronLeftIcon />}
          variant="ghost"
          color="#37F091"
          _hover={{ bg: 'rgba(55, 240, 145, 0.1)' }}
          _active={{ bg: 'rgba(55, 240, 145, 0.2)' }}
          size="sm"
          onClick={onPrevMonth}
        />

        <Text fontWeight="bold" fontSize="lg" textAlign="center">
          {monthYear}
        </Text>

        <IconButton
          aria-label="Próximo mês"
          icon={<ChevronRightIcon />}
          variant="ghost"
          color="#37F091"
          _hover={{ bg: 'rgba(55, 240, 145, 0.1)' }}
          _active={{ bg: 'rgba(55, 240, 145, 0.2)' }}
          size="sm"
          onClick={onNextMonth}
        />
      </Flex>
      <SimpleGrid columns={7} spacing={1} textAlign="center">
        {weekdayLabels.map((day, index) => (
          <Text key={index} fontSize="sm" fontWeight="medium" color="gray.600">
            {day}
          </Text>
        ))}
      </SimpleGrid>
    </Box>
  )
}
